
import Vue from "vue";
import { getCurrentUser } from "./auth";
import Header from "./layouts/Header.vue";
import GlobalToast from "./components/GlobalToast.vue";
export default Vue.extend({
  name: "App",
  data: () => ({}),
  components: {
    Header,
    GlobalToast,
  },
  computed: {
    isAuthenticated() {
      return getCurrentUser();
    },
  },
});
